var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVagrantOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vagrant",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1159cc}.cls-2{fill:#127eff}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "original"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.5 23.9V12.82L95.91 28.3v9.34l-21.28 45.9-10.64 7.33v33.61l22.81-13.15 35.7-87.43zM63.99 66.94L48.04 29.71V19.19l-.11-.06-15.84 9.17v9.34l21.27 47.91 10.63-5.25V66.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.55 3.52L79.97 19.09l-.02-.01V29.71L63.99 66.94v12.45l-10.63 6.16-21.27-47.91v-9.36l15.96-9.19-26.6-15.57-15.95 9.3v11.42l35.9 87.2 22.59 13.04V91.72l10.64-6.17-.13-.08 21.41-47.83v-9.36l26.59-15.46-15.95-9.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVagrantOriginal);
export default __webpack_public_path__ + "static/media/VagrantOriginal.095d9d3e592aea38adb6b585d42c880e.svg";
export { ForwardRef as ReactComponent };